import {Routes} from "@angular/router";
import {CfConfigPage} from "./page/overview/cf-config/cf-config.page";

export function CfSubRoutes(): Routes {

    const routes = [
        {path: 'cf/config', component: CfConfigPage}
    ];

    return routes;

}
